export default class MaterialSheetDocument {
  public id?: number;
  public originalName!: string;
  public size!: number;
  public documentUri?: string;
  public file?: File;
  public createdAt?: string;
  public toDelete?: boolean;

  constructor(data?: Partial<MaterialSheetDocument>) {
    Object.assign(this, data);
  }

  isPersisted(): boolean {
    return this.id !== undefined;
  }
}
